import { logger } from './logger';

export const getSearchResultsPath = (): string => {
  logger.log('process.env', process.env, 'process.env.VUE_APP_FSS_RESULTS', process.env.VUE_APP_FSS_RESULTS);
  return process.env.VUE_APP_FSS_RESULTS + '';
};
